import React, { Component } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import { store, persistor } from './store/index'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import './app.css'
import NavBar from './components/navBar/navBar'
import Login from './pages/auth/login'
import MainPage from './pages/mainPage'
import { setPercentage } from './store/actions/percentage'


/* -----Lists----- */
import BitkiCesitleriList from './pages/bitkiCesitleri/bitkiCesitleriList'
import BitkiSekilleriList from './pages/bitkiSekilleri/bitkiSekilleriList'
import BoyutlarList from './pages/boyutlar/boyutlarList'
import RenklerList from './pages/renkler/renkList'
import SonucCicekList from './pages/sonucCicek/sonucCicekList'
import SonucCicekGaleriList from './pages/sonucCicek/sonucCicekResimGaleri'
import AgacCaliList from './pages/agacCali/agacCaliList'
import YaprakTipiList from './pages/yaprakTipi/yaprakTipiList'
import YaprakSekliList from './pages/yaprakSekli/YaprakSekliList'
import SonucAgacList from './pages/sonucAgac/sonucAgacList'
import SonucAgacResimGaleri from './pages/sonucAgac/sonucAgacResimGaleri'

/* ------DataEnter------- */
import BitkiCesitleriEnter from './pages/bitkiCesitleri/bitkiCesitleriEnter'
import BitkiSekilleriEnter from './pages/bitkiSekilleri/bitkiSekilleriEnter'
import BoyutlarEnter from './pages/boyutlar/boyutlarEnter'
import RenklerCreate from './pages/renkler/renkEnter'
import SonucCicekEnter from './pages/sonucCicek/sonucCicekEnter'
import SonucCicekGaleriEnter from './pages/sonucCicek/sonucCicekResimGaleriEnter'
import AgacCaliEnter from './pages/agacCali/agacCaliEnter'
import YaprakTipiEnter from './pages/yaprakTipi/yaprakTipiEnter'
import YaprakSekliEnter from './pages/yaprakSekli/yaprakSekliEnter'
import SonucAgacEnter from './pages/sonucAgac/sonucAgacEnter'
import SonucAgacResimGaleriCreate from './pages/sonucAgac/SonucAgacResimGaleriEnter'

/* -------Detay------- */
import DetayCreator from './components/detay/detayCreator'

class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      token: "asd",
      reload: false
    }
  }

  async logout(token) {
    if (token !== this.state.token) {
      await this.setState({ token })
    }
  }

  render() {

    if (store.getState().auth.token === "" && this.state.token !== "asd") {
      return (
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
              <NavBar logout={this.logout.bind(this)} />
              <Switch>
                <Route path="/login" component={Login} />
                <Route path="/" component={Login}><Redirect to="/login"></Redirect></Route>
              </Switch>
            </BrowserRouter>
          </PersistGate>
        </Provider >
      )
    }
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <NavBar logout={this.logout.bind(this)} />
            <Switch>
              <Route path="/Admin" component={MainPage} />
              <Route path="/bitkiCesitleri" component={BitkiCesitleriList} />
              <Route path="/bitkiSekilleri" component={BitkiSekilleriList} />
              <Route path="/boyutlar" component={BoyutlarList} />
              <Route path="/renkler" component={RenklerList} />
              <Route path="/sonucCicek" component={SonucCicekList} />
              <Route path="/sonucCicekResimGaleri" component={SonucCicekGaleriList} />
              <Route path="/agacCali" component={AgacCaliList} />
              <Route path="/yaprakTipi" component={YaprakTipiList} />
              <Route path="/yaprakSekli" component={YaprakSekliList} />
              <Route path="/sonucAgac" component={SonucAgacList} />
              <Route path="/sonucAgacResimGaleri" component={SonucAgacResimGaleri} />

              <Route path="/bitkiCesitleriCreate" component={BitkiCesitleriEnter} />
              <Route path="/bitkiSekilleriCreate" component={BitkiSekilleriEnter} />
              <Route path="/boyutlarCreate" component={BoyutlarEnter} />
              <Route path="/renkCreate" component={RenklerCreate} />
              <Route path="/sonucCicekCreate" component={SonucCicekEnter} />
              <Route path="/sonucCicekGaleriCreate" component={SonucCicekGaleriEnter} />
              <Route path="/agacCaliCreate" component={AgacCaliEnter} />
              <Route path="/yaprakTipiCreate" component={YaprakTipiEnter} />
              <Route path="/yaprakSekliCreate" component={YaprakSekliEnter} />
              <Route path="/sonucAgacCreate" component={SonucAgacEnter} />
              <Route path="/sonucAgacGaleriCreate" component={SonucAgacResimGaleriCreate} />

              <Route path="/detay" component={DetayCreator} />
            </Switch>


          </BrowserRouter>
        </PersistGate>
      </Provider >
    );


  }
}

export default App
